import { Env } from '@magicdoorinc/env';
import { getEnv } from '~/utils/env';
import type VConsole from 'vconsole';

const isMobileDevice = () => {
  if (typeof window === 'undefined') return false;
  return /(Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini)/i.test(navigator.userAgent);
};

const shouldEnableVConsole = () => {
  if (!isMobileDevice()) return false;

  if (import.meta.env.DEV) return true;

  const env = getEnv();
  if (env === Env.Test) return true;

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('vconsole') === '1') return true;

  return false;
};

let vconsoleInstance: VConsole | null = null;

export const initVConsole = async () => {
  if (!shouldEnableVConsole()) return;

  if (vconsoleInstance) return;

  const { default: VConsoleModule } = await import('vconsole');

  if (vconsoleInstance) return;

  vconsoleInstance = new VConsoleModule({
    theme: 'light',
    defaultPlugins: ['system', 'network', 'element', 'storage'],
  });
};

export const destroyVConsole = () => {
  if (vconsoleInstance) {
    vconsoleInstance.destroy();
    vconsoleInstance = null;
  }
};
